import http from '@/config/api';
import router from '@/router';
import { addressApi } from '@/config/addressApi';

export default {
  getShopList({ commit }, params) {
    http.get('/shops', { params }).then((res) => {
      commit('SET_SHOP_LIST', res.data);
    });
  },
  async getShopDetail({ commit }, params) {
    const res = await http.get(`/shop/${params.shopId}`, { params }).then(
      (res) => {
        let address = `${res.data.prefectureName || ''}${res.data.municipalityName || ''}${res.data.streetAddress ||
          ''}${res.data.buildingName || ''}`;
        res.data.address = address;
        commit('SET_SHOP_DETAIL', res.data);
        return res.data;
      },
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return res;
  },
  async getShopByCode({ commit }, shopCode) {
    const directory = router.currentRoute.value?.params.directory;
    const res = await http.get(`event/${directory}/shop/code/${shopCode}`).then(
      (res) => {
        commit('SET_SHOP_DETAIL', res.data);
        return res.data;
      },
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return res;
  },
  async getAmountPoint({ commit }, payload) {
    const directory = router.currentRoute.value?.params.directory;
    return await http.post(`event/${directory}/shop/${payload.shopId}/planned_point`, {
      amount: payload.amount,
      total: payload.total
    }).then((response) => {
      if (response) {
        commit('SET_NEW_POINT', response?.data?.point);
        return response;
      }
    });
  },
  async getParentShopId({ commit }, shopCode) {
    const res = await http.get(`event/shop/code/${shopCode}`).then(
      (res) => {
        commit('SET_PARENT_SHOP_ID', res);
        return res?.data;
      },
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return res;
  },
  async getParentShopByCode({ commit }, shopCode) {
    const res = await http.get(`event/shop/${shopCode}/total/pay/compute`).then(
      (res) => {
        commit('SET_PARENT_SHOP_DETAIL', res.data);
        return res.data;
      },
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return res;
  },
  async postParentShopCode({ commit }, payload) {
    return await http.post(`event/shop/${payload.shopCode}/total/pay/compute`, { amount: payload.amount }).then((response) => {
      if (response) {
        commit('SET_PARENT_SHOP_DETAIL', response?.data);
        return response;
      }
    });
  },
  async handleToggleFavorite(store, payload) {
    if (payload.isFavorite) {
      const res = await http.delete(`/favorite/shop/${payload.shopId}`).then(
        (res) => res.data,
        () => null
      );
      if (res) {
        store.commit('SET_FAVORITE', { key: 'shopListData', id: payload.shopId, isFavorite: res.isFavorite });
        store.commit('SET_FAVORITE', { key: 'favoriteShopListData', id: payload.shopId, isFavorite: res.isFavorite });
        if (payload.reload) {
          store.commit('REMOVE_ITEM_FAVORITE', { key: 'shopListData', id: payload.shopId });
          store.commit('REMOVE_ITEM_FAVORITE', { key: 'favoriteShopListData', id: payload.shopId });
        }
      }
    } else {
      const res = await http.post(`/favorite/shop/${payload.shopId}`).then(
        (res) => res.data,
        () => null
      );
      if (res) {
        store.commit('SET_FAVORITE', { key: 'shopListData', id: payload.shopId, isFavorite: res.isFavorite });
        store.commit('SET_FAVORITE', { key: 'favoriteShopListData', id: payload.shopId, isFavorite: res.isFavorite });
      }
    }
  },
  async handleFavoriteGallery(_, payload) {
    if (payload.isFavorite) {
      const res = http.delete(`/favorite/shop/${payload.shopId}/gallery/${payload.galleryId}`).then(
        (res) => res.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
      return res;
    } else {
      http.post(`/favorite/shop/${payload.shopId}/gallery/${payload.galleryId}`);
    }
  },
  async handleFavoriteCoupon(store, payload) {
    if (payload.isFavorite) {
      const res = await http.delete(`/favorite/shop/${payload.shopId}/coupon/${payload.couponId}`).then(
        (res) => res?.data,
        () => null
      );
      if (res) {
        store.commit('SET_FAVORITE', { key: 'couponsData', id: payload.couponId, isFavorite: res?.isFavorite });
        store.commit('SET_FAVORITE', { key: 'favoriteCouponsData', id: payload.couponId, isFavorite: res?.isFavorite });
        if (payload.reload) {
          store.commit('REMOVE_ITEM_FAVORITE', { key: 'couponsData', id: payload.couponId });
          store.commit('REMOVE_ITEM_FAVORITE', { key: 'favoriteCouponsData', id: payload.couponId });
        }
      }
    } else {
      const res = await http.post(`/favorite/shop/${payload.shopId}/coupon/${payload.couponId}`).then(
        (res) => res?.data,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
      if (res && !res.error) {
        store.commit('SET_FAVORITE', { key: 'couponsData', id: payload?.couponId, isFavorite: res?.isFavorite });
        store.commit('SET_FAVORITE', { key: 'favoriteCouponsData', id: payload?.couponId, isFavorite: res?.isFavorite });
      }
    }
  },
  async searchShop({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .get('/shops?', {
        params: {
          ...payload.query,
          directory,
          offset: payload.offset,
          limit: payload.limit,
        },
        isLoading: true,
      })
      .then((res) => {
        commit('SET_SHOP_LIST', res?.data);
        return res?.data;
      });
    return response;
  },
  async useCoupon(_, payload) {
    const res = await http.post(`/shop/${payload.shopId}/coupon/${payload.couponId}`, payload, { closeUseCoupon: true }).then(
      (res) => res?.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
    return res;
  },
  async fetchPrefectures({ commit }) {
    commit('SET_PREFECTURES', []);
    http.get('/prefectures', addressApi).then((res) => {
      commit('SET_PREFECTURES', res.data);
    });
  },
  async fetchMunicipalities({ commit }, prefectureId) {
    commit('SET_MUNICIPALITY', []);
    http.get(`/municipalities/${prefectureId}`, addressApi).then((res) => {
      commit('SET_MUNICIPALITY', res.data);
    });
  },
  async fetchShopPrefectures({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    http.get(`/event/${directory}/shop/prefectures`).then((res) => {
      commit('SET_SHOP_PREFECTURES', res.data);
    });
  },
  async fetchShopMunicipalities({ commit }, prefectureId) {
    const directory = router.currentRoute.value?.params.directory;
    http.get(`/event/${directory}/shop/municipalities/${prefectureId}`).then((res) => {
      commit('SET_SHOP_MUNICIPALITIES', res.data);
    });
  },
  async resetMunicipalities({ commit }) {
    commit('SET_MUNICIPALITY', []);
  },
  async resetShopMunicipalities({ commit }) {
    commit('SET_SHOP_MUNICIPALITIES', []);
  },
  async fetchGenres({ commit }) {
    const directory = router.currentRoute.value?.params.directory;
    http.get('/genres', {
      params: {
        directory,
      }
    }).then((res) => {
      commit('SET_GENRE', res.data.list);
    });
  },
  async resetState({ commit }) {
    commit('RESET_STATE');
  },
  async getFavoriteShops({ commit }, params) {
    await http
      .get('shops', {
        params: {
          offset: params.offset,
          limit: params.limit,
          isFavorite: true,
          ...params,
        },
      })
      .then((res) => {
        commit('SET_FAVORITE_SHOP_LIST', res.data);
      });
  },
  async getCoupons({ commit }, params) {
    await http
      .get(`shop/${params.shopId}/coupons`, {
        params: {
          offset: params.offset,
          limit: params.limit,
        },
        isLoading: true,
      })
      .then((res) => {
        if (params?.isWithoutLoadmore) {
          commit('SET_COUPONS', res.data);
        } else {
          commit('ADD_COUPONS', res.data);
        }
      });
  },
  async getPhotos({ commit }, params) {
    await http
      .get(`shop/${params.shopId}/galleries`, {
        params: {
          offset: params.offset,
          limit: params.limit,
        },
      })
      .then((res) => {
        if (params.type === 'loadmore') {
          commit('ADD_PHOTO_LIST', {
            list: res.data.list,
          });
        } else {
          commit('SET_PHOTOS', res?.data);
        }
      });
  },
  async getFavoritePhotos({ commit }, params) {
    await http
      .get('/favorite/galleries', {
        params: {
          offset: params.offset,
          limit: params.limit,
          ...params,
        },
      })
      .then((res) => {
        if (params.type === 'loadmore') {
          commit('ADD_FAVORITE_PHOTO_LIST', {
            list: res.data.list,
          });
        } else {
          commit('SET_FAVORITE_PHOTOS', res?.data);
        }
      });
  },
  async getFavoriteCoupons({ commit }, params) {
    await http
      .get('/favorite/coupons', {
        params: {
          offset: params.offset,
          limit: params.limit,
          ...params,
        },
      })
      .then((res) => {
        commit('SET_FAVORITE_COUPONS', res.data);
      });
  },
  getMenu({ commit }, params) {
    http
      .get(`shop/${params.shopId}/menus`, {
        params: {
          offset: params.offset,
          limit: params.limit,
        },
      })
      .then((res) => {
        if (params.type === 'loadmore') {
          commit('ADD_MENU_LIST', {
            list: res.data.list,
          });
        } else {
          commit('SET_MENU', res.data);
        }
      });
  },
  async getCouponDetail({ commit }, payload) {
    await http.get(`shop/${payload.shopId}/coupon/${payload.couponId}`).then((res) => {
      commit('SET_COUPON_DETAIL', res.data);
    });
  },
  async getGalleryDetail({ commit }, payload) {
    await http.get(`shop/${payload.shopId}/gallery/${payload.galleryId}`).then((res) => {
      commit('SET_GALLERY_DETAIL', res.data);
    });
  },
  async getItemByCategories({ commit }, payload) {
    if (payload.type === 'menu') {
      await http
        .get(`shop/${payload.shopId}/menus`, {
          params: {
            categoryId: payload.id,
            offset: payload.offset,
            limit: payload.limit,
          },
        })
        .then((res) => {
          commit('SET_MENU', res.data);
        });
    } else {
      await http
        .get(`shop/${payload.shopId}/galleries`, {
          params: {
            categoryId: payload.id,
            offset: payload.offset,
            limit: payload.limit,
          },
        })
        .then((res) => {
          commit('SET_PHOTOS', res?.data);
        });
    }
  },
  async payTicket(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .post(`event/${directory}/shop/${payload.shopId}/pay/ticket`, {
        total: payload.total,
        amount: payload.amount,
        passcode: payload.passcode,
        paymentToken: payload.paymentToken,
        ticketBreakdown: payload.ticketBreakdown,
        memo1: payload.memo1,
        memo2: payload.memo2,
        memo3: payload.memo3,
      })
      .then(
        (res) => res,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  async payProduct(_, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .post(`event/${directory}/shop/${payload.shopId}/pay`, {
        total: payload.total,
        point: payload.point,
        amount: payload.amount,
        passcode: payload.passcode,
        paymentToken: payload.paymentToken,
        memo1: payload.memo1,
        memo2: payload.memo2,
        memo3: payload.memo3,
      })
      .then(
        (res) => res,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  async payParentProduct(_, payload) {
    const response = await http
      .post(`/event/shop/${payload.shopCode}/total/pay`, {
        amount: payload.amount,
        passcode: payload.passcode,
        paymentToken: payload.paymentToken,
        memo1: payload.memo1,
        memo2: payload.memo2,
        memo3: payload.memo3,
      })
      .then(
        (res) => res,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  async getTokenPay(_, payload) {
    return await http
      .post(`event/${payload.directory}/payment-token`, {
        feature: payload.feature,
      })
      .then(
        (res) => res.data.paymentToken,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
  },
  async getTokenParentPay(_, payload) {
    return await http
      .post('event/payment-token', {
        feature: payload.feature,
      })
      .then(
        (res) => res.data.paymentToken,
        (err) => ({
          error: {
            ...err,
          },
        })
      );
  },
  async getBarcodeQr({ commit }, payload) {
    const directory = payload?.directory || router.currentRoute.value?.params.directory;
    const response = await http
      .get(`event/${directory}/qr`, payload)
      .then(
        (res) => {
          commit('SET_BAR_CODE_QR', res.data?.code);
          return res.data;
        },
        (err) => ({
          error: {
            ...err,
          },
        })
      );
    return response;
  },
  getBarcodeQrStatus(_, params) {
    const directory = params?.directory || router.currentRoute.value?.params.directory;
    return http.get(`event/${directory}/qr/${params?.code}/status`).then(
      (response) => response?.data,
      (err) => ({
        error: {
          ...err,
        },
      })
    );
  },
};
